module.exports = __webpack_public_path__ + "img/feature-1.9b03ab8b.png";